import { styled as a, Box as i, Typography as g } from "@mui/material";
import { formatNumberString as c } from "../../temp-lib/util/misc/formatNumberString.js";
import { noForwardProps as h } from "../../temp-lib/util/styled/index.js";
import { useRef as b, useEffect as y } from "react";
import _ from "react-countup";
import { jsxs as m, jsx as t } from "react/jsx-runtime";
const o = 1.75, $ = 0, k = a(i)`
  align-items: center;
  display: flex;
  gap: 3px;
  justify-content: center;
  position: relative;

  ${(e) => e.theme.breakpoints.up("res768")} {
    height: 32px;
    width: 225px;
    border-radius: 3.5px;
    border: 3.5px solid #888;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    height: 20px;
    width: 100%;
    border-radius: 2.5px;
    border: 2.5px solid #888;
  }
`, w = a(i, h)`
  @keyframes pulse {
    0% {
      transform: scale(1) translateX(0);
    }
    50% {
      transform: scale(1.02, 1.15) translateX(-1%);
    }
    100% {
      transform: scale(1) translateX(0);
    }
  }

  @keyframes expand {
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  }

  height: 100%;
  position: absolute;
  transform-origin: left;
  width: 100%;

  ${(e) => e.__max ? `
          animation: pulse 0.8s infinite ease-in-out, expand ${o}s ease-out;
          background: linear-gradient(
            90deg,
            #5e16ff 0%,
            #5e16ff 100%
          );
        ` : `
          animation: expand ${o}s ease-out;
          background: linear-gradient(
            90deg,
            #f55b8e 0%,
            #f55b8e ${e.__progress}%,
            transparent ${e.__progress}%,
            transparent 100%
          );
        `}
`, s = a(g)`
  font-weight: 300;
  line-height: unset;
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 12px;
  }
`, X = a(i)`
  align-items: center;
  display: flex;
  gap: 3px;
  position: relative;
`, T = ({
  className: e,
  progress: r,
  nextLevelPoint: n
}) => {
  const l = b(r), f = r / n * 100, p = r > n, u = c(`${r}`, {
    allowedLargeNumberAbbr: !1
  }), d = c(`${n}`, {
    allowedLargeNumberAbbr: !1
  });
  return y(() => {
    l.current = r;
  }, [r]), /* @__PURE__ */ m(k, {
    className: e,
    children: [/* @__PURE__ */ t(w, {
      className: "Custom-Background",
      __max: p,
      __progress: f
    }), /* @__PURE__ */ m(X, {
      children: [/* @__PURE__ */ t(_, {
        delay: $,
        duration: o,
        end: r,
        start: l.current,
        children: ({
          countUpRef: x
        }) => /* @__PURE__ */ t(s, {
          ref: x,
          children: u
        })
      }), /* @__PURE__ */ t(s, {
        children: "/"
      }), /* @__PURE__ */ t(s, {
        children: d === "0" ? "--" : d
      })]
    })]
  });
};
export {
  T as default
};
//# sourceMappingURL=LevelProgressBar.js.map
